/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pin': {
    width: 21,
    height: 21,
    viewBox: '0 0 21 21',
    data: '<path pid="0" _fill="#7b7b7b" d="M20.847 6.01L14.936.155a.55.55 0 00-.774 0l-.025.025a1.88 1.88 0 00-.322 2.263l-6.186 5.26a2.577 2.577 0 00-1.718-.649c-.69 0-1.338.266-1.825.75l-.037.036a.538.538 0 000 .766l3.541 3.51-3.449 3.416c-.069.07-1.702 1.737-2.775 3.064C.344 19.857.142 20.089.131 20.1a.537.537 0 00.024.739.548.548 0 00.748.026c.01-.008.237-.205 1.52-1.224 1.339-1.063 3.021-2.68 3.098-2.755l3.444-3.411 3.352 3.32a.547.547 0 00.773 0l.037-.036a2.529 2.529 0 00.756-1.809c0-.634-.232-1.232-.655-1.702l5.31-6.128c.28.155.597.238.927.238.513 0 .995-.198 1.357-.557l.025-.025a.538.538 0 000-.766z"/>'
  }
})
